import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { ResponsePayload, Sitemap } from "@/types";
import { fetchSitemap } from "./thunk";

export const emptySitemap = (): Sitemap => ({
  header: [],
  hubs: [],
  projects: [],
  footer: [],
  pages: []
});

export interface SitemapState {
  sitemap: Sitemap;
  status: "idle" | "fetching" | "saving";
  error: string | null;
}

const initialState: SitemapState = {
  sitemap: emptySitemap(),
  error: null,
  status: "idle"
};

export const sitemapSlice = createSlice({
  name: "sitemap",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        const incoming = action.payload?.[sitemapSlice.name];
        if (!incoming) {
          return state;
        }
        return {
          ...state,
          ...incoming
        };
      })
      .addCase(fetchSitemap.pending, (state) => {
        state.status = "fetching";
        state.error = null;
      })
      .addCase(fetchSitemap.fulfilled, (state, action) => {
        state.status = "idle";
        state.sitemap = action.payload ?? emptySitemap();
      })
      .addCase(fetchSitemap.rejected, (state, action) => {
        const { statusText } = (action.payload as ResponsePayload) || {};

        state.status = "idle";
        state.sitemap = emptySitemap();
        state.error = statusText ?? action.error.message ?? null;
      });
  }
});
